export const workingHours = {
  weekdays: 'We\'re available Monday - Friday from 9am - 8:45pm',
  weekend: 'Saturday & Sunday from 9am - 7:45pm',
}
